import { ChangeEvent } from 'react'

import Icon from '../icon/Icon'
import { FILTERS, SORTS } from './helpers'
import {
  ToolbarRoot,
  FilterRow,
  FilterChip,
  ChipGlyph,
  SortRow,
  SortLabel,
  SortSelect,
  CountHint,
} from './styled'
import {
  ListingsSortOrder,
  ListingsTagFilter,
  ListingsToolbarProps,
} from './types'

/**
 * Filter chip row + sort dropdown for the saved-listings page. Stateless
 * — selection is owned by the caller.
 *
 * @param {ListingsToolbarProps} props
 * @returns {JSX.Element}
 */
const ListingsToolbar = ({
  tagFilter,
  sortOrder,
  onTagFilterChange,
  onSortOrderChange,
  totalCount,
  visibleCount,
}: ListingsToolbarProps): JSX.Element => {
  const handleSortChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    onSortOrderChange(event.target.value as ListingsSortOrder)
  }

  return (
    <ToolbarRoot>
      <FilterRow>
        {FILTERS.map(descriptor => (
          <FilterChip
            key={descriptor.filter}
            type="button"
            isActive={tagFilter === descriptor.filter}
            onClick={() =>
              onTagFilterChange(descriptor.filter as ListingsTagFilter)
            }
          >
            <ChipGlyph aria-hidden="true">
              <Icon icon={descriptor.glyph} />
            </ChipGlyph>
            {descriptor.label}
          </FilterChip>
        ))}
        {visibleCount !== totalCount ? (
          <CountHint>
            Showing {visibleCount} of {totalCount}
          </CountHint>
        ) : null}
      </FilterRow>
      <SortRow>
        <SortLabel htmlFor="listings-sort">Sort</SortLabel>
        <SortSelect
          id="listings-sort"
          value={sortOrder}
          onChange={handleSortChange}
        >
          {SORTS.map(descriptor => (
            <option key={descriptor.order} value={descriptor.order}>
              {descriptor.label}
            </option>
          ))}
        </SortSelect>
      </SortRow>
    </ToolbarRoot>
  )
}

export default ListingsToolbar
